<template>
  <div class="flex items-baseline justify-between gap-4 px-3">
    <span class="text-subtitle">{{ label }}</span>
    <VProgressCircular
      v-if="loading"
      indeterminate
      size="14"
      width="2"
      color="primary"
      data-testid="aki-infobox-row-spinner"
    />
    <span v-else class="text-subtitle text-right" data-testid="aki-infobox-row-value">
      {{ value }}
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string
  value: string
  loading?: boolean
}>()
</script>
